import { searchInputStyles } from "@insite/content-library/Widgets/Header/SearchInput";
import Search from "@insite/mobius/Icons/Search";
import { css } from "styled-components";

searchInputStyles.input = {
    sizeVariant: "default",
    iconProps: { 
        src: Search},
    border: "rectangle", // full rectangle border
    cssOverrides: {
        formField: css`
            width: 457px; // longer search box
            height: 48px;
            > div button {  
                top: 4px !important;
            }
        `,    

    },
};

searchInputStyles.popoverWrapper = {
    css: css`
    div:nth-child(2) {
        top: auto !important;
        right: auto !important;
      }
`,
}

